import { Component, HostListener, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { ChatStore } from '../store/chat.store';
import { AudioTaskStore } from '../store/audio-task.store';

@Component({
  selector: 'app-home',
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './home.html',
  styleUrls: [
    './home.scss',
    '../../styles/_common.scss'
  ]
})
export class Home {
  protected isHeaderMenuOpen = false;

  private readonly _authService = inject(AuthService);
  private readonly _chatStore = inject(ChatStore);
  private readonly _router = inject(Router);
  private readonly _audioTaskStore = inject(AudioTaskStore);

    @HostListener('window:click', ['$event'])
    onGlobalClick(event: MouseEvent) {
        const element = event.target as HTMLElement;
        if (element.id === 'header-menu' || element.id === 'header-dropdown-panel') {
            return;
        }
        this.isHeaderMenuOpen = false;
    }

    @HostListener('window:touchstart', ['$event'])
    onTouchStart(event: TouchEvent) {
        const element = event.target as HTMLElement;
        if (element.id === 'header-menu' || element.id === 'header-dropdown-panel') {
            return;
        }
        this.isHeaderMenuOpen = false;
    }

  protected logout() {
    this._authService.signOut();
    this.isHeaderMenuOpen = false;
  }

  protected startNewConversation() {
    this._audioTaskStore.stopCurrentTask();
    this._chatStore.startNewConversation();
    this._router.navigate(['/', 'home', 'voice']);
  }
}
